module.exports = __webpack_public_path__ + "img/hsk_duschkabine.317a2c8b.jpg";